var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiamondBnw({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1.6vw",
    height: "1.6vw",
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 14,
    fill: "#262626"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1305 9.23422L11.9344 12.3333L14.0004 18.7658M14.0004 18.7658L16.1208 12.2789L14.979 9.23422M14.0004 18.7658L8.40039 12.3876M14.0004 18.7658L19.6004 12.3876M8.40039 12.3876L10.7926 9.23422H17.2625L19.6004 12.3876M8.40039 12.3876H19.6004",
    stroke: "#FCFAFA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiamondBnw);
export default __webpack_public_path__ + "static/media/diamond_bnw.1ed3e1a7197ab287fe87654d60f3b671.svg";
export { ForwardRef as ReactComponent };